import React from 'react';
import HolderIcon from '../../ressources/images/icons/v3/holder.svg';
import MultiHolderIcon from '../../ressources/images/icons/v3/multiHolder.svg';
import LegalIcon from '../../ressources/images/icons/v3/legal.svg';
import ArrowIcon from '../../ressources/images/icons/arrow-down.svg';

const BILHoldersSelectionItem = ({ ownershipType, holderNames, isExpanded, onClick }) => (

   <div className="BILHolders-selection-item" onClick={onClick}>
      <img
         src={ownershipType === "LEGAL" ? LegalIcon : holderNames.length > 1 ? MultiHolderIcon : HolderIcon}
         className="BILHolders-selection-item__avatar" alt={ownershipType}
      />
      <div className="BILHolders-selection-item__container" >
         {
            holderNames.length > 0 ?

               holderNames.map((holderName, i) => {
                  return (
                     <div key={holderName.fullName + i}>
                        <div key={holderName.fullName} className="BILHolders-selection-item__name">
                           {holderName.fullName}
                        </div>
                        <div key={holderName.partyId} className="BILHolders-selection-item__partyId" >
                           {holderName.partyId}
                        </div>
                     </div>
                  )
               })
               :
               <div>
                  <div className="BILHolders-selection-item__name">
                     NOT AVAILABLE
                  </div>
                  <div className="BILHolders-selection-item__partyId" >
                     NOT AVAILABLE
                  </div>
               </div>
         }
      </div>
      {
         !isExpanded ?
            <div className="BILHolders-selection-item__arrow">
               {
                  <img src={ArrowIcon} alt="Close list" style={{ width: '14px', height: '14px' }} />
               }
            </div>
            :
            <div className="BILHolders-selection-item__arrow__down">
               {
                  <img src={ArrowIcon} alt="Close list" style={{ width: '14px', height: '14px' }} />
               }
            </div>
      }
   </div>

)

export default BILHoldersSelectionItem

